import "../assets/Modal.css";
import { defineComponent as r, openBlock as l, createElementBlock as a, unref as o, createElementVNode as s, createVNode as i, withModifiers as m } from "vue";
import { d } from "./debounce.BDLEW31m.js";
import { p as c } from "./widgets-core.es.DdX21Kyh.js";
import { _ } from "./XClose.vue_vue_type_style_index_0_lang.BbzrX7pV.js";
import { t as p } from "./useModal.CgbJKM9V.js";
const f = ["aria-label"], u = ["innerHTML"], C = /* @__PURE__ */ r({
  __name: "Modal",
  props: {
    termsText: {}
  },
  setup(M) {
    const { t } = c(), e = d(p, 200, { leading: !0, trailing: !1 });
    return (n, g) => (l(), a("div", {
      class: "thn--tool-terms__modal",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": o(t)("Terms and conditions")
    }, [
      s("div", {
        class: "thn--tool-terms__modal-text",
        innerHTML: n.termsText
      }, null, 8, u),
      i(_, {
        "only-close-modal": !0,
        onMousedown: m(o(e), ["left"]),
        onClick: o(e)
      }, null, 8, ["onMousedown", "onClick"])
    ], 8, f));
  }
});
export {
  C as _
};
//# sourceMappingURL=Modal.vue_vue_type_style_index_0_lang.D99GhTsY.js.map
